<template>
   <a-drawer width="60%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>

    <a-card :bordered="false">
      <!-- 條件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="刷手號" prop="userNum">
                <a-input v-model="queryParam.userNum" placeholder="請輸入刷手號" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="類型" prop="type">
                <a-select v-model="queryParam.type" placeholder="請選擇類型" allow-clear>
                  <a-select-option :value="0">瀏覽</a-select-option>
<!--                  <a-select-option :value="1">點擊</a-select-option>-->
<!--                  <a-select-option :value="2">下載</a-select-option>-->
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查詢</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
<!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['adv:platform:add']">-->
<!--          <a-icon type="plus" />新增-->
<!--        </a-button>-->
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['adv:platform:edit']">-->
<!--          <a-icon type="edit" />修改-->
<!--        </a-button>-->
<!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['adv:platform:remove']">-->
<!--          <a-icon type="delete" />刪除-->
<!--        </a-button>-->
         <a-button type="primary" @click="handleExport">
          <a-icon type="download" />匯出
       </a-button>
      </div>
     <div>
      <span>瀏覽小計:</span><span style="margin-left: 10px;color: red;font-weight: bold;">{{ this.subtotal.viewPrice }}</span>
<!--      <span style="margin-left:10px;">點擊小計:</span><span style="margin-left: 10px;color: red;font-weight: bold;">{{ this.subtotal.clickPrice }}</span>-->
      <span style="margin-left:10px;">總計:</span><span style="margin-left: 10px;color: red;font-weight: bold;"> {{ this.subtotal.totalPrice }}</span>
     </div>
      <!-- 數據展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
      </a-table>
      <!-- 分頁 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 條`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>

  </a-drawer>
</template>

<script>
import { pageBrowse,listBrowse, delBrowse,getProccSubtotal } from '@/api/platform/slideshowBrowse'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'browse',
  components: {

  },
  mixins: [tableMixin],
  data () {
    return {
      formTitle: '執行記錄',
      // 1增加,2修改
      formType: 1,
      open: false,
      list: [],
      subtotal: {},
      selectedRowKeys: [],
      selectedRows: [],
      // 高級搜索 展開/關閉
      advanced: false,
      // 非單個禁用
      single: true,
      // 非多個禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查詢參數
      queryParam: {
        userNum: null,
        browseId: null,
        type: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
      {
          title: '刷手號',
          dataIndex: 'userNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '暱稱',
          dataIndex: 'nickname',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '類型',
          dataIndex: 'type',
          ellipsis: true,
          align: 'center',
          customRender: function (value, record) {
            if (value == 0) {
              return "瀏覽"
            }else if (value == 1) {
              return "點擊"
            }else if (value == 2) {
              return "下載"
            }else {
              return "-"
            }
          }
        },
        {
          title: '瀏覽時間段',
          dataIndex: 'time',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '瀏覽時間',
          dataIndex: 'browseTime',
          ellipsis: true,
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getProccSubtotal()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按鈕
    cancel () {
      this.open = false
      this.reset()
    },
    /** 修改按鈕操作 */
    getProccSubtotal () {
      getProccSubtotal({"browseId":this.queryParam.browseId}).then(response => {
        this.subtotal = response.data
      })
    },
    /** 查詢用戶-瀏覽列表 */
    getList (browseId) {
      this.formType = 1
      this.open = true
      this.loading = true
      this.queryParam.browseId = browseId
      pageBrowse(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
        this.getProccSubtotal()
      })
    },

    /** 搜索按鈕操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList(this.queryParam.browseId)
    },
    /** 重置按鈕操作 */
    resetQuery () {
      this.queryParam = {
        userId: undefined,
        browseId: this.queryParam.browseId,
        type: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList(this.queryParam.browseId)
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList(this.queryParam.browseId)
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 刪除按鈕操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '確認刪除所選中數據?',
        content: '當前選中編號為' + ids + '的數據',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delBrowse(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList(this.queryParam.browseId)
              that.$message.success(
                '刪除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空刪除ids列表
          that.ids = []
        }
      })
    },
    /** 導出按鈕操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否確認導出?',
        content: '此操作將導出當前條件下所有數據而非選中數據',
        onOk () {
          that.download('/platform/slideshow-browse/export', {
            ...that.queryParam
          }, `用戶-瀏覽_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
